/**
 * LogicaAprovisionamiento.jsx · v101.129.0 · Pestaña «Lógica de aprovisionamiento» del Centro de Validaciones.
 * Documento (docs/logica-aprovisionamiento.md) con el orden de revisiones de cada aprovisionamiento; cada código de
 * validación (`prov.…`, `fin.…`, `cierre.…`, `inv.…`) muestra al lado si hoy está prendida o apagada.
 */
import { useMemo, useState } from "react";
import { Search, BookOpen } from "lucide-react";
import raw from "../docs/logica-aprovisionamiento.md";
import { parseSections, SectionContent } from "../pages/ManualTiposSolucion";

export default function LogicaAprovisionamiento({ system = [] }) {
  const [q, setQ] = useState("");
  const [active, setActive] = useState(null);
  const sections = useMemo(() => {
    const state = {};
    (system || []).forEach((it) => { state[it.code] = it.enabled !== false; });
    // `código` → `código` «prendida» / «APAGADA» (estado real del Centro de Validaciones)
    const md = raw.replace(/`((?:prov|fin|cierre|inv|devolucion)\.[a-z_]+)`/g, (m, code) =>
      code in state ? `${m} «${state[code] ? "prendida" : "APAGADA"}»` : m);
    return parseSections(md);
  }, [system]);
  const norm = (t) => (t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  const nq = norm(q.trim());
  const visible = nq
    ? sections.filter((s) => norm(s.title).includes(nq) || norm(s.lines.join(" ")).includes(nq))
    : sections;
  const go = (num) => {
    setActive(num);
    const el = document.getElementById(`logica-sec-${num}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[230px_1fr] gap-4" data-testid="logica-aprovisionamiento">
      <aside className="rounded-2xl border border-slate-200 bg-white p-3 h-max lg:sticky lg:top-4">
        <div className="relative mb-2">
          <Search size={13} className="absolute left-2 top-2 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar…"
            className="w-full border rounded-lg pl-7 pr-2 py-1.5 text-xs" data-testid="logica-search" />
        </div>
        <nav className="space-y-0.5 max-h-[70vh] overflow-y-auto">
          {visible.map((s) => (
            <button key={s.num} onClick={() => go(s.num)}
              className={`w-full text-left px-2 py-1 rounded text-[11px] ${active === s.num ? "bg-[#0A3747] text-white" : "text-slate-700 hover:bg-slate-100"}`}>
              {s.num}. {s.title}
            </button>
          ))}
        </nav>
      </aside>
      <div className="space-y-4 min-w-0">
        {visible.length === 0 && <div className="text-xs text-slate-500">Sin coincidencias.</div>}
        {visible.map((s) => (
          <section key={s.num} id={`logica-sec-${s.num}`} className="rounded-2xl border border-slate-200 bg-white p-4 scroll-mt-4">
            <h2 className="flex items-center gap-2 text-sm font-bold text-[#0A3747] mb-2">
              <BookOpen size={15} /> {s.num}. {s.title}
            </h2>
            <SectionContent section={s} searchTerm={q.trim()} />
          </section>
        ))}
      </div>
    </div>
  );
}
